import React, { useState } from 'react';
import { Type, Plus, Minus, RotateCcw } from 'lucide-react';
import { Button } from './ui/button';
import { useAccessibility } from '../contexts/AccessibilityContext';

export const TextScaleControl = () => {
  const { textScale, increaseTextSize, decreaseTextSize, resetTextSize } = useAccessibility();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setIsOpen(!isOpen)}
        className="rounded-full transition-transform hover:scale-110"
        aria-label="Text size controls"
      >
        <Type className="h-5 w-5 text-gray-700 dark:text-gray-300" />
      </Button>

      {isOpen && (
        <div className="absolute right-0 top-12 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg p-3 z-50 min-w-[200px]">
          <div className="text-sm font-semibold mb-2 text-gray-900 dark:text-white">Text Size</div>
          <div className="flex items-center gap-2 mb-2">
            <Button
              variant="outline"
              size="sm"
              onClick={decreaseTextSize}
              disabled={textScale <= 0.8}
              className="flex-1"
            >
              <Minus className="h-4 w-4" />
            </Button>
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300 min-w-[3rem] text-center">
              {Math.round(textScale * 100)}%
            </span>
            <Button
              variant="outline"
              size="sm"
              onClick={increaseTextSize}
              disabled={textScale >= 1.5}
              className="flex-1"
            >
              <Plus className="h-4 w-4" />
            </Button>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={resetTextSize}
            className="w-full"
          >
            <RotateCcw className="h-4 w-4 mr-2" />
            Reset
          </Button>
        </div>
      )}
    </div>
  );
};